import styled, { css } from 'styled-components';
import { getDarkenColor, getColorAlias, transparentizeAliasColor } from '../../../utils/index.js';
import { ButtonLarge, ButtonMedium, ButtonSmall, ButtonXSmall } from '../styles.js';

const GhostButtonStyles = css `
  background-color: ${({ isLoading }) => isLoading
    ? getDarkenColor('active02', 'backgroundDefault')
    : 'transparent'};
  color: ${getColorAlias('contentLink')};

  &:hover {
    background-color: ${({ isLoading }) => isLoading ? 'default' : getDarkenColor('hover01', 'backgroundDefault')};
  }

  &:active {
    background-color: ${getDarkenColor('active02', 'backgroundDefault')};
  }

  &:disabled {
    background-color: transparent;
    color: ${getColorAlias('contentDisabled')};
  }

  svg {
    fill: ${getColorAlias('contentLink')};
  }

  ${(props) => props.isLoading &&
    css `
      &,
      :disabled,
      :disabled:hover {
        background-color: ${getDarkenColor('active01', 'disabled01')};
      }
    `}
`;
const GhostButtonLarge = styled(ButtonLarge) `
  ${GhostButtonStyles};
`;
const GhostButtonMedium = styled(ButtonMedium) `
  ${GhostButtonStyles};
`;
const GhostButtonSmall = styled(ButtonSmall) `
  ${GhostButtonStyles};
`;
const GhostButtonXSmall = styled(ButtonXSmall) `
  ${GhostButtonStyles};
`;
const GhostInverseButton = css `
  background-color: transparent;
  color: ${getColorAlias('contentInteractivePrimary')};

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.mode === 'dark'
    ? transparentizeAliasColor('hover02', 'backgroundDark')
    : getDarkenColor('hover01', 'backgroundDark')};
  }

  &:active:not(:disabled) {
    background-color: ${(props) => props.theme.mode === 'dark'
    ? transparentizeAliasColor('active02', 'backgroundDark')
    : getDarkenColor('active02', 'backgroundDark')};
  }

  &:disabled {
    background-color: transparent;
    color: ${getColorAlias('contentDisabled')};
  }

  svg {
    fill: ${getColorAlias('contentLight')};
  }

  ${(props) => props.isLoading &&
    css `
      &,
      :disabled,
      :disabled:hover {
        background-color: ${transparentizeAliasColor('active02', 'containerDefault')};
      }
    `}
`;
const GhostInverseButtonLarge = styled(ButtonLarge) `
  ${GhostInverseButton};
`;
const GhostInverseButtonMedium = styled(ButtonMedium) `
  ${GhostInverseButton};
`;
const GhostInverseButtonSmall = styled(ButtonSmall) `
  ${GhostInverseButton};
`;
const GhostInverseButtonXSmall = styled(ButtonXSmall) `
  ${GhostInverseButton};
`;

export { GhostButtonLarge, GhostButtonMedium, GhostButtonSmall, GhostButtonXSmall, GhostInverseButtonLarge, GhostInverseButtonMedium, GhostInverseButtonSmall, GhostInverseButtonXSmall };
